module.exports = __webpack_public_path__ + "static/Check-Penta-c142a7a3f3f8851d1bb89129a747d929.png";